<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" placeholder="" @keyup.enter.native="getImportRecordListHandle"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" placeholder=""
                    @keyup.enter.native="getImportRecordListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="用户名称：">
                <el-select v-model="searchForm.userId" clearable filterable>
                    <el-option v-for="item in userList" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商名称：">
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                        :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="getImportRecordListHandle" plain
                    icon="el-icon-search">搜索查询</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="showManyCardImport()">导入与修改</el-button>
                <el-button type="danger" class="onlyBtn" plain @click="showImportApply">批量删除卡板</el-button>
                <el-button type="primary" @click="whiteClick">白名单</el-button>
                <el-button type="primary" class="onlyBtn" plain @click="authStopFlg = true">设置实名停机</el-button>
            </el-form-item>

        </el-form>

        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
            <el-table-column prop="intoNo" label="接入号" align="center"></el-table-column>
            <el-table-column prop="userName" label="代理商" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" align="center"></el-table-column>
            <el-table-column prop="limitAuthTime" label="实名限制时间" align="center"></el-table-column>

            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="selectCmccInfo(scope.row)">查询详情</el-button>
                    <el-button type="text" size="small" @click="selectCmccInfoStart(scope.row)">开启数据</el-button>
                    <el-button type="text" size="small" @click="selectCmccInfoStop(scope.row)">关闭数据</el-button>
                    <el-button type="text" size="small" @click="selectFuji(scope.row)">复机</el-button>
                </template>
            </el-table-column>


            <!-- <el-table-column label="操作" align="center" fixed="right" width="200">
                <template slot-scope="scope">
                <el-button type="text" size="small" @click="getImportFailRecordListHandle(scope.row.id, $event)">查询详情</el-button>
                <el-button type="text" size="small" @click="exportApplyHandler(scope.row.id)">数据导出</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <template v-if="batchImport">
                    <el-form-item label="导入Excel：" prop="uploadExcel">
                        <el-upload ref="upload" :action="uploadUrl('pool/excel/update/pool')" :headers="setHeader()"
                            :limit="1" :auto-upload="false" :data="importCardForm" :on-change="handleChange"
                            :on-success="handleSuccess">
                            <el-button slot="trigger" plain>导入Excel</el-button>
                            <el-button style="margin-left: 10px;" plain
                                @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                        </el-upload>

                    </el-form-item>
                </template>
                <el-form-item label="操作类型：" prop="isReward">
                    <el-radio-group v-model="importCardForm.isReward">
                        <el-radio label="0">新卡导入</el-radio>
                        <el-radio label="1">修改池组</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="所属代理商：" prop="userId">
                    <el-select v-model="importCardForm.userId" filterable>
                        <el-option v-for="item in userList" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="所属供应商：" prop="supplierCode">
                    <el-select v-model="importCardForm.supplierCode" filterable>
                        <el-option v-for="item in branchSupplierOption" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="数据详情" :visible.sync="importFailVisible" width="1000px"
            :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="stateName" label="状态"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>



            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>


        <el-dialog :append-to-body="true" title="删除池组卡板" :visible.sync="importVisible" width="600px"
            :close-on-click-modal="false">
            <el-form :model="searchForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('pool/excel/delete/pool')" :headers="setHeader()"
                        :limit="1" :auto-upload="false" :on-success='handleSuccessSn'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="提示" :visible.sync="confirmExportDialogVisible" width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>




        <!--白名单弹窗-->
        <el-dialog :append-to-body="true" title="白名单" :visible.sync="whiteShow" width="600px"
            :close-on-click-modal="false">
            <el-input v-model="querd.ip" placeholder="请输入IP" clearable
                style="width:200px;margin-right:10px;"></el-input>
            <el-button type="default" @click="selectIp()">查询</el-button>
            <el-button type="primary" @click="addIp()">添加</el-button>
            <el-button type="danger" @click="deleteIp()">删除</el-button>
        </el-dialog>




        <el-dialog :append-to-body="true" title="移动信息" :visible.sync="cmccFlg" width="600px"
            :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>数据状态：</label>
                <span>{{ cmccInfoData.dataName }}</span>
            </div>
            <div class="lineInDialog">
                <label>卡板状态：</label>
                <span>{{ cmccInfoData.stateName }}</span>
            </div>

            <div class="lineInDialog">
                <label>停机原因：</label>
                <span>{{ cmccInfoData.stopMessage }}</span>
            </div>
            <div class="lineInDialog">
                <label>是否冻结：</label>
                <span>{{ cmccInfoData.dongjie }}</span>
            </div>
            <div class="lineInDialog">
                <label>是否实名：</label>
                <span>{{ cmccInfoData.authName }}</span>
            </div>
            <div class="lineInDialog">
                <label>加入群组：</label>
                <span>{{ cmccInfoData.groupName }}</span>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cmccFlg = false">取 消</el-button>
            </span>
        </el-dialog>





        <el-dialog :append-to-body="true" title="设置实名停机" :visible.sync="authStopFlg" width="600px"
            :close-on-click-modal="false">
            <el-form :model="searchForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('pool/excel/auth/pool')" :headers="setHeader()"
                        :limit="1" :auto-upload="false" :on-success='handleSuccessSn'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=poolAuth')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="authStopFlg = false">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { oneCardImport, getImportRecordList, getImportFailRecordList, oneCardImport1, oneCardImport12 } from '@/api/sim.js'
import { getSimTypeOption } from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data() {
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if (len > 0) {
                var extName = files[0].name.split('.')[1].toLowerCase();
                if (extName != 'xls' && extName != 'xlsx') {
                    return callback(new Error('请选择要导入的Excel文件'));
                } else {
                    callback();
                }
            } else {
                return callback(new Error('请选择要导入的Excel文件'))
            }
        }
        return {
            authStopFlg: false,
            querd: {
                ip: ''
            },
            userList: [],

            agentAccountForm: {
                name: '',
                sysUserAccountName: '',
                accountState: ''
            },
            searchForm: {
                name: '',
            },
            importCardForm: {
                iccid: '',
                userId: '',
                supplierCode: '',
                intoNoEnd: '',
                intoNo: '',
                agentId: '',
                supplierCode: '',
                poolId: '',
                cardType: '0',
                isReward: '0',
                virtualNo: ''
            },
            importCardVisible: false,
            batchImport: true,
            copyImport: false,
            batchSimsImport: false,
            importFailVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            currentId_fail: '',
            pkgGroup: [],
            agentListOption: [],
            branchSupplierOption: [],
            simTypeOption: [],
            title: '',
            importCardRules: {
                uploadExcel: [{ required: true, validator: checkImportFile }],
                poolId: [{ required: true, message: '请选择池组', trigger: 'change' }],
                remark: [{ required: true, message: '请选择本次导入的备注', trigger: 'change' }],
            },


            importVisible: false,

            confirmExportDialogVisible: false,

            whiteShow: false,


            cmccInfoData: {},
            cmccFlg: false,
        }
    },
    methods: {
        selectCmccInfo(row) {
            var data = {
                iccid: row.iccid,
                supplierCode: row.supplierCode,
                isApp: "1s"
            }
            common.sysRequest('sim/select/cmcc/info', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.cmccInfoData = res.data.data;
                    this.cmccFlg = true;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        selectCmccInfoStart(row) {
            var data = {
                iccid: row.iccid,
                supplierCode: row.supplierCode
            }

            common.sysRequest('sim/select/state/start', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        selectCmccInfoStop(row) {
            var data = {
                iccid: row.iccid,
                supplierCode: row.supplierCode
            }
            common.sysRequest('sim/select/state/stop', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
         selectFuji(row) {
            var data = {
                iccid: row.iccid,
                supplierCode: row.supplierCode
            }
            common.sysRequest('sim/startFuji', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },

        addIp() {
            common.sysRequest('sim/add/ip', this.querd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('操作成功');
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        deleteIp() {
            common.sysRequest('sim/delete/ip', this.querd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('操作成功');
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        selectIp() {
            common.sysRequest('sim/select/ip', this.querd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('存在');
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },

        //白名单
        whiteClick() {
            this.whiteShow = true
        },

        exportApplyHandler(id) {
            var data = {
                id: id
            }
            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('export/importInfo', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            }).catch(() => {

            });
        },





        handleSuccessSn(res) {
            if (res.code == 200) {
                this.importVisible = false;
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        showImportApply() {
            this.importVisible = true;
        },
        importApplyHandler() {
            this.$refs.upload.submit();
        },
        importCancel() {
            this.importVisible = false;
        },






        cancel() {
            this.batchSimsImport = false;
            this.importCardVisible = false;
            this.$refs.importCardForm.resetFields();
        },
        handleChange(file, fileList) {
            if (fileList.length > 0) {
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },
        getImportRecordListHandle($event) {
            common.resetCurrentPage(this, $event, "tbpg");
            var data = common.getRequestParams(this, "tbpg", this.searchForm);
            common.sysRequest('pool/select/sim/page', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getImportFailRecordListHandle(id, $event) {
            this.importFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            common.sysRequest('pool/select/sim/page/info', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showManyCardImport() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "批量导入";
            this.batchImport = true;
        },
        showOneCardImport() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "单卡导入";
            this.batchImport = false;
        },
        showOneCardImport1() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "号段导入";
            this.batchSimsImport = true;
            this.batchImport = false;
        },
        showOneCardImport12() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "复制导入";
            this.copyImport = true;
            this.batchSimsImport = false;
            this.batchImport = false;
        },
        getOptionsOfSelect() {
            common.getAgentListOptionCom(this, 'agentListOption');
            common.sysRequest('pool/select/pool/user/list', {}, 'post').then(res => {
                this.pkgGroup = res.data.data;
            })
            common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
            getSimTypeOption().then(res => {
                if (res.data.code == 200) {
                    this.simTypeOption = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureImportCardHandle() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    if (this.batchImport) {
                        this.$refs.upload.submit();   //号段批量导入
                    } else {
                        var data = this.importCardForm;
                        common.sysRequest('pool/excel/update/pool/batch', data, 'post').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success('导入完成！');
                                this.getImportRecordListHandle();
                                this.importCardVisible = false;
                                this.batchSimsImport = false;
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }

                }
            })
        },
        handleSuccess(res) {
            if (res.code == 200) {
                this.importCardVisible = false;
                this.getImportRecordListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val) {
            if (this.importFailVisible) {
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            } else {
                this.tbpg.pageSize = val;
                this.getImportRecordListHandle();
            }
        },
        handleCurrentChange(val) {
            if (this.importFailVisible) {
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val;
                this.getImportRecordListHandle();
            }
        }
    },
    created() {
        this.getImportRecordListHandle();
        common.sysRequest('lunxun/select/pool/user/list', {}, 'post').then(res => {
            if (res.data.code == 200) {
                this.userList = res.data.data;
            } else {
                this.$message.error(res.data.message);
            }
        })
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
    }
}
</script>

<style lang="less" scoped></style>
